import { PreparedWorkload } from 'features/workload-optimization';

import { HpaNotSupportedMessage } from './_components/HpaNotSupportedMessage';

import { HpaSettingsLegacyForm } from './_components/HpaSettingsLegacyForm';
import { HpaVersionOutdatedMessage } from '../../../../_components/HpaVersionOutdatedMessage';
import { useHpaV2Status } from '../../../../_hooks/useHpaV2Status';
import {
  isHpaV2UnavailableOnTakeOwnership,
  isHpaV2UnavailableOnWorkloadType,
  workloadHasNativeHpaSettings,
  workloadOwnershipWasTaken,
} from '../../../../_utils';
import { NativeHpaSettings } from '../HorizontalRightsizingSettings/NativeHpaSettings';
import { HpaUnsupportedOwnershipBanner } from './_components/HpaUnsupportedOwnershipBanner';
import { HpaOwnershipNotTakenBanner } from '../HorizontalRightsizingSettings/HpaOwnershipNotTakenBanner';
import { HpaSettingsV2Form } from './_components/HpaSettingsV2Form';
import { useWorkloadHasLegacyHpaSettings } from '../../../../_hooks/useWorkloadHasLegacyHpaSettings';
import { Stack } from '@cast/design-system';

export const HorizontalRightsizingSettingsV2 = ({
  workload,
}: {
  workload: PreparedWorkload;
}) => {
  const { hpaV2Status } = useHpaV2Status();

  const { workloadHasLegacyHpaSettings } = useWorkloadHasLegacyHpaSettings({
    workload,
  });

  if (hpaV2Status === 'outdated') {
    return <HpaVersionOutdatedMessage />;
  }
  if (isHpaV2UnavailableOnWorkloadType(workload)) {
    return <HpaNotSupportedMessage />;
  }

  if (workloadHasNativeHpaSettings(workload)) {
    if (isHpaV2UnavailableOnTakeOwnership(workload)) {
      return (
        <Stack gap={24}>
          <HpaUnsupportedOwnershipBanner workload={workload} />
          <NativeHpaSettings hideOldWarning />
        </Stack>
      );
    }

    // Ownership was not taken
    if (!workloadOwnershipWasTaken(workload)) {
      return (
        <Stack gap={24}>
          <HpaOwnershipNotTakenBanner />
          <NativeHpaSettings hideOldWarning />
        </Stack>
      );
    }
  }

  if (workloadHasLegacyHpaSettings) {
    return <HpaSettingsLegacyForm />;
  }

  return <HpaSettingsV2Form workload={workload} />;
};
